/** Hide internal SSA / settlement wording in wallet transaction notes (investor UI). */

export function sanitizeInvestorWalletNote(note) {
  let s = String(note ?? "").trim();
  if (!s) return "";

  s = s.replace(/,?\s*fee\s+([\d.]+)\s+as\s+[\d.]+\s+shares?\s+to\s+SSA/gi, ", fee $1");
  s = s.replace(/\s+as\s+[\d.]+\s+shares?\s+to\s+SSA/gi, "");
  s = s.replace(/\s+shares?\s+to\s+SSA/gi, "");
  s = s.replace(/\s+to\s+SSA\b/gi, "");
  s = s.replace(/share\s+component\s+credited\s+to\s+SSA/gi, "fee");
  s = s.replace(/share-?settled\s+to\s+SSA/gi, "fee from shares");
  s = s.replace(/\s*\(cap\s+unchanged\)\s*/gi, " ");

  const replacements = [
    ["Secondary transfer fee — fee", "Transfer fee"],
    ["Redemption fee — fee", "Redemption fee"],
    ["Share transfer fee — fee", "Transfer fee"],
    ["net of share-settled fee", "after fee"],
    ["share-settled fee", "fee"],
    ["Share transfer fee revenue (cash)", "Transfer fee"],
    ["Share transfer fee (cash)", "Transfer fee"],
  ];
  for (const [from, to] of replacements) {
    s = s.split(from).join(to);
  }

  s = s.replace(/\s{2,}/g, " ").replace(/\(\s*\)/g, "").trim(" ,;");
  return s;
}
